<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
    />
    <MediaObjectForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import MediaObjectForm from "../../components/mediaobject/Form";

const servicePrefix = 'MediaObject';

export default {
  name: 'MediaObjectUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    MediaObjectForm,
    Loading,
    Toolbar,
  },

  computed: {
    ...mapFields('mediaobject', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('mediaobject', ['find'])

  },

  methods: {
    ...mapActions('mediaobject', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
